import Link from 'next/link'
import React, {useContext} from "react"
import styles from '../login/loginForm.module.css'
import {useForm} from "react-hook-form";
import {yupResolver} from '@hookform/resolvers/yup';
import * as yup from "yup";
import {recover} from './api'
import {useRouter} from 'next/router'


const schema = yup.object().shape({
    email: yup.string().required("Please enter your email address.").min(5, "Email is too short"),
    recover: yup.string().required("Please chose what to recover"),
});

export default function ForgotForm() {
    const router = useRouter();
    const {email} = router.query;
    const {register, handleSubmit, errors, setError, setValue, getValues} = useForm({
        defaultValues: {
            email: email,
            recover: "password"
        },
        resolver: yupResolver(schema)
    });

    const [done, setDone] = React.useState(false);

    if (getValues("email") === "" && email !== "") {
        setValue("email", email);
    }

    const onSubmit = async data => {
        const response = await recover(data.email, data.recover);
        console.log(response);
        if (response.status) {
            setDone(true);
        } else {
            setError("email", {message: response.error, type: "login error"});
        }
    }


    return (
        <div className="contentdiv" id="login-form">

            {Object.keys(errors).length > 0 &&
            <div className={`${styles.bsCallout} ${styles.bsCalloutWarning}`}>
                <h4>Please correct the errors below!</h4>
            </div>}
            {!done &&
                <div style={{color: "#999"}}>
                    Please enter your email address below and we will send you instructions on resetting.
                </div>
            }
            <div>
                {done &&
                <div>
                    <div style={{"fontSize": "120%", marginTop: "15px", marginBottom: "25px"}}>
                        Request received. Please check your email.
                    </div>
                    <a href={"/login"}>Login</a>
                </div>
                }
            </div>
            {(!done && <form onSubmit={handleSubmit(onSubmit)}>
                <div className="content">
                    <div className="inputdiv parsley-success" data-id="#recover" id="recover">
                        <div className="pos-rel">
                            <input name="recover" type="radio" value="password" ref={register}/>
                            Password
                            <span className="radio-fill"></span>
                        </div>

                        <br/>
                        <div className="pos-rel">
                            <input name="recover" type="radio"
                                   value={"username"} ref={register}
                            /> Username
                            <span className="radio-fill"></span>
                        </div>
                    </div>

                    <div>
                        <div className={`${styles.inputdiv} inputdiv ${errors.email ? styles.error : ""}`}>
                            <input type="text" placeholder="Email Address" name="email" ref={register}/>
                            <span><i className="fa fa-envelope" aria-hidden="true"></i></span>
                        </div>
                        {errors.email &&
                        <ul className={`${styles.errorsList} ${styles.list} filled`} aria-hidden="false">
                            <li className="required">{errors.email.message}
                            </li>
                        </ul>}

                    </div>
                </div>
                <div className="contentfooter">
                    <button type="submit" className="submitbtn">
                        Submit
                    </button>
                    <Link href={"/submit-extension?email=" + getValues("email")}>
                        <a href={"/submit-extension"}>
                            Register Account</a>
                    </Link>
                    <a id="urlLink" style={{display: "none"}} href="https://google.com">&nbsp;</a>
                    <iframe src="about:blank" style={{display: "none"}} width="1" height="1" id="goif"></iframe>
                </div>
            </form>)}

        </div>
    )
}
